import {
  IAdminTemplate,
  IResponseWithPagination,
  ITemplate,
  ITemplateCategory,
  ITemplateCollection,
  ITemplateProvider
} from '@/types';
import { request } from '@/utils';

// template-admin/templates?keyword=&page=1&size=10
export const queryAdminTemplates = async (
  params?: Record<string, any>
): Promise<IResponseWithPagination<ITemplate>> => {
  return request({
    url: '/template-admin/templates',
    method: 'GET',
    params
  });
};

// /template-admin/templates/3
export const queryAdminTemplate = async (id: string): Promise<IAdminTemplate> => {
  return request({
    url: `/template-admin/templates/${id}`,
    method: 'GET'
  });
};

// POST /template-admin/templates
export const createAdminTemplate = async (data: Partial<ITemplate>): Promise<any> => {
  return request({
    url: '/template-admin/templates',
    method: 'POST',
    data
  });
};

//PUT /template-admin/templates/4
export const updateAdminTemplate = async (id: string, data: Partial<ITemplate>): Promise<any> => {
  return request({
    url: `/template-admin/templates/${id}`,
    method: 'PUT',
    data
  });
};

//DELETE /template-admin/templates/4
export const deleteAdminTemplate = async (id: string): Promise<any> => {
  return request({
    url: `/template-admin/templates/${id}`,
    method: 'DELETE'
  });
};

// /templates/categories
export const queryTemplateCategories = async (): Promise<{ rows: ITemplateCategory[] }> => {
  return request({
    url: '/templates/categories',
    method: 'GET'
  });
};

// templates/providers
export const queryTemplateProviders = async (): Promise<{ rows: ITemplateProvider[] }> => {
  return request({
    url: '/templates/providers',
    method: 'GET'
  });
};

// /template-admin/templates/collections?categoryId=2
export const queryTemplateCollections = async (
  params?: Record<string, any>
): Promise<{ rows: ITemplateCollection[] }> => {
  return request({
    url: '/template-admin/templates/collections',
    method: 'GET',
    params
  });
};

// templates?page=1&size=20&category=3
export const queryTemplates = async (params?: Record<string, any>): Promise<any> => {
  return request({
    url: '/templates',
    method: 'GET',
    params
  });
};

// /template-admin/templates/5/operation
// {
//   "action": "unhide"
// }
export const updateTemplateOperation = async (data: { action: string; id: string }): Promise<any> => {
  return request({
    url: `/template-admin/templates/${data.id}/operation`,
    method: 'POST',
    data
  });
};
